'use client';

import { FloatingPortal } from '@floating-ui/react';
import { useContext } from 'react';

import { DrawerRootContext } from './context/drawer-root.context';
import type { DrawerPortalPropsInterface } from './types/drawer-portal.types';

/**
 * @since 10.22.0
 */
export const DrawerPortal = (props: DrawerPortalPropsInterface) => {
  const { contained, containerNode, drawer } = useContext(DrawerRootContext);
  const portalRoot = props.root === undefined ? (containerNode ?? undefined) : props.root;

  // Not `drawer.open`: the close transition needs the content to outlive it.
  if (!drawer.isMounted) {
    return null;
  }

  // Only wait for the inferred container. An explicit root takes precedence, including null.
  if (props.root === undefined && contained && !containerNode) {
    return null;
  }

  return <FloatingPortal {...props} root={portalRoot} />;
};

DrawerPortal.displayName = 'Drawer.Portal';
